import AudioLevelIndicator from '../../AudioLevelIndicator/AudioLevelIndicator';
import { LocalAudioTrack } from 'twilio-video';
import { Grid } from '@mui/material';
import { SelectMenu } from '@dtsl/react';
import { SELECTED_AUDIO_INPUT_KEY } from '../../../constants';
import useDevices from '../../../hooks/useDevices/useDevices';
import useMediaStreamTrack from '../../../hooks/useMediaStreamTrack/useMediaStreamTrack';
import useVideoContext from '../../../hooks/useVideoContext/useVideoContext';
import { useTranslation } from 'react-i18next';

export default function AudioInputList() {
  const { audioInputDevices } = useDevices();
  const { localTracks } = useVideoContext();

  const localAudioTrack = localTracks.find((track) => track.kind === 'audio') as LocalAudioTrack;
  const srcMediaStreamTrack = localAudioTrack?.noiseCancellation?.sourceTrack;
  const mediaStreamTrack = useMediaStreamTrack(localAudioTrack);

  const deviceId = srcMediaStreamTrack?.getSettings().deviceId || mediaStreamTrack?.getSettings().deviceId;
  const deviceLabel = srcMediaStreamTrack?.label || mediaStreamTrack?.label;

  const localAudioInputDevice = [
    {
      key: deviceId,
      value: deviceId,
      label: deviceLabel,
    },
  ];
  const { t } = useTranslation();

  function replaceTrack(newDeviceId: string) {
    window.localStorage.setItem(SELECTED_AUDIO_INPUT_KEY, newDeviceId);
    localAudioTrack?.restart({ deviceId: { exact: newDeviceId } });
  }

  const options = audioInputDevices.map((device) => ({
    key: device.deviceId,
    value: device.deviceId,
    label: device.label,
  }));

  return (
    <div>
      <Grid container alignItems="flex-end" justifyContent="space-between">
        <div className="inputSelect">
          {audioInputDevices.length > 1 ? (
            <SelectMenu
              label={t('ROOM.MIC_SELECT')}
              options={options}
              onSelect={(selected: { value: string }) => {
                replaceTrack(selected.value);
              }}
              value={localAudioInputDevice || []}
            />
          ) : (
            <p className="sib-typo_text-body">{localAudioTrack?.mediaStreamTrack.label || t('ROOM.MIC_NO_SELECT')}</p>
          )}
        </div>
        <AudioLevelIndicator audioTrack={localAudioTrack} color="black" />
      </Grid>
    </div>
  );
}
